export default "__VITE_ASSET__DADEtU95__"